import React from "react";

interface QuickAmountButtonsProps {
  amounts: number[];
  onSelect: (amount: number) => void;
  selected?: number;
}

const QuickAmountButtons: React.FC<QuickAmountButtonsProps> = ({
  amounts,
  onSelect,
  selected,
}) => {

  return (

    <div>

      <p className="mb-2 text-sm font-medium text-body dark:text-bodydark">
        Selección rápida
      </p>

      <div className="flex flex-wrap gap-2">

        {amounts.map((amount) => {

          const isActive = selected === amount;

          return (

            <button
              key={amount}
              type="button"
              onClick={() => onSelect(amount)}
              className={`
                inline-flex items-center justify-center
                rounded-sm px-3 py-1.5
                text-sm font-semibold
                transition-all duration-150
                active:scale-95
                ${
                  isActive
                    ? "bg-success text-white ring-2 ring-success/40 shadow-sm"
                    : "bg-whiten text-body border border-stroke hover:bg-success hover:text-white dark:bg-boxdark dark:border-strokedark dark:text-bodydark"
                }
              `}
            >
              ${amount}
            </button>

          );

        })}

      </div>

    </div>

  );

};

export default QuickAmountButtons;